/** Display helpers for optional clients-table columns (PM-V4 parity). */

const CAPUM_PAY_STATUS_NAMES: Record<number, string> = {
  0: 'Not Started',
  1: 'Started',
  2: 'Accept Payments',
  3: 'Restricted',
  4: 'In Review',
  5: 'Action Required',
  6: 'Completed',
  7: 'Rejected'
};

export function formatAmlCheckTypeLabel(code: string | null | undefined): string {
  const key = (code ?? '').trim().toUpperCase();
  switch (key) {
    case 'IDAMLNOCRED':
      return 'AML';
    case 'INTID':
      return 'International ID';
    case 'CREDACTIVE':
      return 'Credit';
    case 'COMPUK':
      return 'Company';
    case 'IDSCAN':
      return 'Biometric';
    default:
      return key.length > 0 ? code!.trim() : '—';
  }
}

const CAPUM_PAY_EXCLUDED_TYPES = new Set(['individual', 'trust', 'charity']);

export function isCapiumPayEligibleCompanyType(companyType: string | null | undefined): boolean {
  const key = (companyType ?? '').trim().toLowerCase();
  return key.length > 0 && !CAPUM_PAY_EXCLUDED_TYPES.has(key);
}

export function formatCapiumPayStatusLabel(status: number | null | undefined): string {
  if (status == null || Number.isNaN(status)) {
    return '—';
  }
  return CAPUM_PAY_STATUS_NAMES[status] ?? `Status ${status}`;
}

/** PM-V4 parity: onboarding % is shown in a progress bar, not in the status label. */
export function capiumPayOnboardingProgressPercent(percentage: number | null | undefined): number {
  const pct = percentage ?? 0;
  if (!Number.isFinite(pct)) {
    return 0;
  }
  return Math.max(0, Math.min(100, Math.round(pct)));
}

/** PM-V4 parity: eligible Capium3 clients with no gateway row show "Not Started" (status 0). */
export function formatCapiumPayStatusLabelForClient(
  status: number | null | undefined,
  ctx: {
    companyType?: string | null;
    companyMasterId?: number;
  }
): string {
  const eligible = isCapiumPayEligibleCompanyType(ctx.companyType);
  const hasLegacyId = (ctx.companyMasterId ?? 0) > 0;
  if ((status == null || Number.isNaN(status)) && eligible && hasLegacyId) {
    return formatCapiumPayStatusLabel(0);
  }
  return formatCapiumPayStatusLabel(status);
}

export function isCapiumPayOnboardingComplete(onboardingStatus: number | null | undefined): boolean {
  const status = onboardingStatus ?? 0;
  return status === 4 || status === 6 || status === 7;
}
